import React from 'react';
import { useState } from 'react';
import { ButtonBack } from '../../common/Button/ButtonBack';

type MileageRewardProductProps = {
  addRemoveProduct: () => void;
};

const MileageRewardProduct = ({
  addRemoveProduct
}: MileageRewardProductProps): JSX.Element => {
  const [buttonText, setButtonText] = useState<string>('Remove');
  const [includeProduct, setIncludeProduct] = useState(true);

  const onClick = () => {
    addRemoveProduct();
    setButtonText(includeProduct ? 'Add' : 'Remove');
    setIncludeProduct(!includeProduct);
  };

  return (
    <div className='flex-row mileage-reward-product'>
      <div className='narrow-column'>
        <img
          alt-text='milage-reward-image'
          src='./brands/renault/renault-austral.jpg'
          className='mileage-reward-product-image'
        />
      </div>
      <div className='wide-column'>
        <h4>
          You qualify for our Mileage Reward product and it's currently free!
        </h4>
        <p>
          Mileage Reward gives you money back at the end of your insurance
          policy if you complete less than 10,000 miles during the year*.
          There's no need for a black box or device - by including this product,
          you allow us to collect this data directly from your connected
          Austral. It's our way of rewarding low mileage drivers with money
          back.
        </p>
        <p>*Terms and conditions apply.</p>
      </div>
      <div className='narrow-column'>
        <ButtonBack
          name='btn-remove'
          text={buttonText}
          onClick={onClick}
          additionalClassNames='btn-add-remove'
        />
      </div>
    </div>
  );
};

export default MileageRewardProduct;
